import React from 'react';
import { PageTitle, PageSubtitle } from '@shared/components/texts/Titles';
import * as S from './partnerships-section.styles';
import { PARTNERSHIPS_SECTION_TEXTS, PARTNER_BOXES } from './partnerships-section.constants';
import GridItem from './grid-item/grid-item';


export const PartnershipsSection = () => (
    <S.Wrapper>
        <S.Header>
            <PageTitle>{PARTNERSHIPS_SECTION_TEXTS.TITLE}</PageTitle>
            <PageSubtitle>
                {PARTNERSHIPS_SECTION_TEXTS.SUBTITLE}
            </PageSubtitle>
        </S.Header>
        <S.CampaignsComponentWrapper>
            {
                PARTNER_BOXES
                    .map(partnerInfo => (
                        <GridItem
                            {...partnerInfo}
                            isDisabled={!partnerInfo.isActive}
                        />
                    ))
            }
        </S.CampaignsComponentWrapper>
    </S.Wrapper>
);
